<template>
  <card id="clusterProperties" no-header no-body no-footer>
    <template #card-table>
      <table class="table table-sm table-ellipsis mb-0">
        <tbody>
          <tr>
            <td class="text-uppercase">{{ $t('c-properties:name') }}</td>
            <td>{{ cluster.name }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">{{ $t('c-properties:customer') }}</td>
            <td v-if="cluster.customer">{{ cluster.customer.name }}</td>
            <td v-else class="text-muted">{{ $t('c-properties:unknown') | capitalize }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">{{ $t('c-properties:payloadType') }}</td>
            <td>{{ cluster.hexa ? $t('c-properties:payloadTypeHexa') : $t('c-properties:payloadTypeB64') | capitalize }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">{{ $t('c-properties:pushEnabled') }}</td>
            <td>{{ cluster.pushEnabled ? $t('c-properties:yes') : $t('c-properties:no') | capitalize }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">{{ $t('c-properties:pushConfiguration') }}</td>
            <td v-if="cluster.pushConfiguration">{{ cluster.pushConfiguration.name }}</td>
            <td v-else class="text-muted">-</td>
          </tr>
          <tr>
            <td class="text-uppercase">{{ $t('c-properties:geoloc') }}</td>
            <td>{{ cluster.geolocEnabled ? $t('c-properties:yes') : $t('c-properties:no') | capitalize }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">{{ $t('c-properties:geolocExpirationDate') }}</td>
            <td :class="cluster.geolocExpirationDate ? (cluster.geolocExpirationDate < Date.now() ? 'text-danger' : 'text-success') : ''">{{ cluster.geolocExpirationDate || '-' | date }}</td>
          </tr>
        </tbody>
      </table>
    </template>
  </card>
</template>

<script>
export default {
  props: {
    cluster: {
      type: Object,
      required: true
    }
  }
}
</script>
